// Utility to handle ResizeObserver errors
export const handleResizeObserverError = () => {
    // Suppress ResizeObserver loop limit exceeded error
    const resizeObserverError = new Error('ResizeObserver loop limit exceeded');
    const originalError = console.error;

    console.error = (...args: any[]) => {
        if (args[0] === resizeObserverError.message) {
            return;
        }
        originalError.apply(console, args);
    };

    return () => {
        console.error = originalError;
    };
};

// Cleanup function for ResizeObserver
export const cleanupResizeObserver = (element: HTMLElement | null) => {
    if (element) {
        // Force a reflow to clear any pending ResizeObserver notifications
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        element.offsetHeight;
    }
};

// Debounced resize handler to prevent rapid ResizeObserver calls
export const debounceResize = (callback: () => void, delay: number = 100) => {
    let timeoutId: NodeJS.Timeout;

    return () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, delay);
    };
}; 